@let makemakeVisible = makeMakaVisible$ | async;
@let alternativKontaktperson = alternativKontaktperson$ | async;
<div class="row leverantor-container" [formGroup]="leverantorFormGroup">
     @if (deltagare.deltagarTyp !== "ExtraDeltagare") {
    <div class="col-5 p-0">
            <rask-input class="col-8" label="Namn" [value]="getNamn()" [readonly]="true"></rask-input>
            <rask-input class="col-4" label="Telefonnummer" formControlName="smsNummer" placeholder="+467xxxxxxxx"
                    infoText="format för mobilnummer +467xxxxxxxx"></rask-input>
    </div>
    <rask-selector
        aid="signeringsmetod"
        class="col-2"
        label="signeringsmetod"
        formControlName="signeringsmetod"
        [required]="true"
        (change)="signingMetodChange()"
        [values]="getSigneringsmetoder()">
    </rask-selector>

    <div class="col-3">
    @if (showMakeMakeSelection()) {
        <rask-checkbox
            label="Make/Maka"
            class="signerings-checkbox"
            formControlName="signeringMakeMaka">
        </rask-checkbox>
    }
    @if(showForetagSelection()) {
        <rask-checkbox
            label="Annan kontaktperson"
            class="signerings-checkbox"
            formControlName="alternativKontaktperson">
        </rask-checkbox>
    }
    </div>
    <div class="col-1">
            <rask-input-number label="Mottagare" formControlName="inbjudningsOrdning"></rask-input-number>
    </div>

     @if (alternativKontaktperson){
        <div class="col-5 p-0">
            <rask-input class="col-8" label="Namn" formControlName="namn"></rask-input>
            <rask-input class="col-4" label="Telefonnummer" formControlName="smsNummer" placeholder="+467xxxxxxxx"
                infoText="format för mobilnummer +467xxxxxxxx"></rask-input>
        </div>
        <rask-input class="col-3" label="E-post" formControlName="epost" [required]="true"></rask-input>

        }

    @if (makemakeVisible){
    <ng-container formGroupName="makeMaka">
        <div class="col-5 p-0">
            <rask-input class="col-8" label="Namn" formControlName="namn"></rask-input>
            <rask-input class="col-4" label="Telefonnummer" formControlName="smsNummer" placeholder="+467xxxxxxxx"
                infoText="format för mobilnummer +467xxxxxxxx"></rask-input>
        </div>

        <rask-input class="col-3" label="E-post" formControlName="epost" [required]="true"></rask-input>
        <rask-selector
            [required]="true"
            aid="signeringsmetod"
            class="col-2"
            label="signeringsmetod"
            formControlName="signeringsmetod"
            (change)="signingMetodMakeMakaChange()"
            [values]="getSigneringsmetoder()">
        </rask-selector>
    </ng-container>
    }
    @if(!deltagare.epost){
    <rask-validation-message-row message="Leverantör saknar epostadress" type="error">
    </rask-validation-message-row>
    }
}
    @if (deltagare.deltagarTyp === "ExtraDeltagare") {
        <div class="col-5 p-0">
            <rask-input class="col-8" label="Namn" formControlName="namn"></rask-input>
            <rask-input class="col-4" label="Telefonnummer" formControlName="smsNummer" placeholder="+467xxxxxxxx"
                infoText="format för mobilnummer +467xxxxxxxx"></rask-input>
        </div>
        <rask-input class="col-3" label="E-post" formControlName="epost" [required]="true"></rask-input>

        <rask-selector
           aid="signeringsmetod"
            class="col-2"
            label="signeringsmetod"
            formControlName="signeringsmetod"
            [required]="true"
            (change)="signingMetodChange()"
            [values]="getSigneringsmetoder()">
        </rask-selector>
        <div class="col-1">
            <rask-input-number label="Mottagare" formControlName="inbjudningsOrdning"></rask-input-number>
        </div>
        <div class="col-1 delete-button">
             <rask-icon-button (click)="removeDeltagare()" icon="far fa-trash-alt" negative></rask-icon-button>
        </div>
    }
</div>